import { checkReplyValidation } from '@btime/helpers'
import { useEffect } from 'react'

import { getQueryParam } from '../../../../utils/helpers/url'

const useIgnoreValidation = (localReply, setLocalReply) => {
  const ignoreValidation = getQueryParam('ignoreValidation')

  useEffect(() => {
    if (ignoreValidation) {
      setLocalReply(prev => {
        return {
          ...prev,
          question: { ...prev.question, required: false },
          validations: { ...prev.validations, isValid: true }
        }
      })
      return
    }
    setLocalReply(prev => ({
      ...prev,
      validations: checkReplyValidation(localReply)
    }))
  }, [localReply?.value, localReply?.notes, localReply?.documents])

  return ignoreValidation
}

export default useIgnoreValidation
